import routerOptions0 from "/opt/atlassian/pipelines/agent/build/node_modules/.pnpm/nuxt@3.15.1_@types+node@20.13.0_eslint@9.31.0_rollup@4.40.0_sass@1.77.8_stylelint@16.19.0_typ_bpeimtsjf3qzk6byulr4uuumaa/node_modules/nuxt/dist/pages/runtime/router.options.js";
import routerOptions1 from "/opt/atlassian/pipelines/agent/build/app/router.options.ts";
const configRouterOptions = {
  hashMode: false,
  scrollBehaviorType: "auto"
}
export const hashMode = routerOptions0.hashMode ?? false
export default {
...configRouterOptions,
...routerOptions0,
...routerOptions1,
}